module.exports = __webpack_public_path__ + "img/Madagascar.bdd044b5.gif";